export default __webpack_public_path__ + "static/media/halftone_casper.fe532271.png";